import axios from './axios-instance';

export function fetchPage(params) {
  return axios.get('/unioncenter/web-background/account/get-page', { params });
}

export function fetchDetail(payload) {
  return axios.post('/unioncenter/account/detail', payload);
}

export function fetchProductStoreList(payload) {
  return axios.post('/unioncenter/product/storeList', payload);
}

export function add(payload) {
  return axios.post('/unioncenter/web-background/account/create', payload);
}

export function edit(payload = {}) {
  return axios.post('/unioncenter/web-background/account/edit', payload);
}

export function updateStatus({ status, accountName }) {
  return axios.get(`/unioncenter/web-background/account/${status}`, { params: { accountName } });
}

export function del(params = {}) {
  return axios.get('/unioncenter/web-background/account/delete', { params });
}

export function unLock(params = {}) {
  return axios.get('/unioncenter/web-background/account/unLock', { params });
}

export function fetchFormatList(payload = {}) {
  return axios.get('/unioncenter/common/format/list', payload);
}

export function fetchCityList(payload = {}) {
  return axios.get('/unioncenter/common/province/list', payload);
}

export function fetchStoreList(payload = {}) {
  return axios.post('/unioncenter/management/store/list', payload);
}
